/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Modal from "../Modal";
import { useSelector } from "react-redux";

import { searchEmployee } from "../../utils/employee";
import SearchEmployee from "./SearchEmployee";

const SearchEmployeePopup = () => {

  const {
    searchEmployeeCallback,
    selectedEmployeeList,
    searchEmployeeOptions,
  } = useSelector(
    (store) => store.Employee
  );
  const cancel = () => {
    // setOpen(false);
    searchEmployee(false);
  };
  const [selectedList, setSelectedList] = useState([]);

  const submit = () => {
    if (searchEmployeeCallback) {
      searchEmployeeCallback(selectedList);
    }
    cancel(null);
  };
  return (
    <Modal
      size="md"
      isOpen={!!searchEmployeeCallback}
      close={cancel}
      className="search-employee"
    >
      <SearchEmployee
        selectedList={selectedList}
        setSelectedList={setSelectedList}
        defaultSelected={selectedEmployeeList}
        title={'사람 선택'}
        {...searchEmployeeOptions}
        submit={submit}
        cancel={cancel}
        isOpen={!!searchEmployeeCallback}
      ></SearchEmployee>
    </Modal>
  );
};

export default SearchEmployeePopup;
